import { render, staticRenderFns } from "./BulkSmsModal.vue?vue&type=template&id=1f66db21&scoped=true"
import script from "./BulkSmsModal.vue?vue&type=script&lang=js"
export * from "./BulkSmsModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSmsModal.vue?vue&type=style&index=0&id=1f66db21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66db21",
  null
  
)

export default component.exports